class AbstractServiceContainer {
    /**
     * Reset all the values stored in the container to the default of undefined.
     */
    reset() {
        // eslint-disable-next-line guard-for-in
        for (let key in this) {
            this[key] = undefined;
        }
    }
}

module.exports = AbstractServiceContainer;
